import axios from 'axios'
import VueCookies from 'vue-cookies'

export default () => ({
  namespaced: true,
  state: {
    tokens: {
      accessToken: null,
      refreshToken: null
    },
    lastRefresh: 0,
    refreshCacheTime: 10 * 1000,
    refreshing: false,
    currentRefresh: null,
    SSO: {
      url: window.globals.VUE_APP_SSOURL,
      appId: window.globals.VUE_APP_SSOAPPID,
      appName: window.globals.VUE_APP_SSOAPPNAME,
      client: window.globals.VUE_APP_SSOCLIENT,
      key: window.globals.VUE_APP_SSOSECRET
    }
  },
  getters: {
    getAccessToken (state) {
      return state.tokens.accessToken
    },
    getRefreshToken (state) {
      return state.tokens.refreshToken
    },
    getTokens (state) {
      return {
        accessToken: state.tokens.accessToken,
        refreshToken: state.tokens.refreshToken
      }
    },
    getSSOCOnfig (state) {
      return state.SSO
    }
  },
  mutations: {
    setAccessToken (state, accessToken) {
      state.tokens.accessToken = accessToken
    },
    setRefreshToken (state, refreshToken) {
      state.tokens.refreshToken = refreshToken
    },
    setLastRefresh (state, lastRefresh) {
      state.lastRefresh = lastRefresh
    },
    setRefreshing (state, refreshing) {
      state.refreshing = refreshing
    },
    setCurrentRefresh (state, currentRefresh) {
      state.currentRefresh = currentRefresh
    }
  },
  actions: {
    clear ({ commit }) {
      commit('setAccessToken', null)
      commit('setRefreshToken', null)
    },
    setTokensFromCookies ({ commit }) {
      commit('setAccessToken', VueCookies.isKey('accessToken') ? VueCookies.get('accessToken') : null)
      commit('setRefreshToken', VueCookies.isKey('refreshToken') ? VueCookies.get('refreshToken') : null)
    },
    setCookiesFromTokens ({ state }) {
      VueCookies.set('accessToken', state.tokens.accessToken)
      VueCookies.set('refreshToken', state.tokens.refreshToken)
    },
    refreshTokens ({ state, commit, dispatch }) {
      if (!state.tokens.refreshToken) {
        return Promise.resolve(false)
      }

      // Stop other calls from immediatly refreshing the token again by waiting a set time before refreshing again
      // This prevents timing issues and a refreshing loop that could overload the oauth server
      // Calls that try to refresh during that time can just try again with the already refreshed tokens
      if (Date.now() < state.lastRefresh + state.refreshCacheTime) {
        return Promise.resolve(true)
      }

      commit('setRefreshing', true)

      const refreshCall = axios.get(`${state.SSO.url}/application/${state.SSO.appId}`, {
        params: {
          appName: state.SSO.appName,
          client: state.SSO.client,
          secret: state.SSO.key,
          refresh_token: state.tokens.refreshToken
        }
      }).then(({ data }) => {
        if (!data.access_token || !data.refresh_token) {
          return Promise.resolve(false)
        }

        commit('setAccessToken', data.access_token)
        commit('setRefreshToken', data.refresh_token)
        dispatch('setCookiesFromTokens')

        commit('setLastRefresh', Date.now())
        commit('setRefreshing', false)
        commit('setCurrentRefresh', null)

        return Promise.resolve(true)
      }).catch(error => {
        console.error(error)
        return Promise.resolve(false)
      })

      commit('setCurrentRefresh', refreshCall)

      return refreshCall
    }
  }
})
